export const POPUP_CANCELLATION_POLICY_CLICKED = 'POPUP_CANCELLATION_POLICY_CLICKED';
export const POPUP_CANCELLATION_POLICY_CLICKED_VERSION = '1.0';

export type PopupCancellationPolicyClickedPayload = {
  searchId: string;
  roomId: string;
  productDetailKey: string;
  optionIndex: number;
  desiredProfitPricingId: string;
};

export type PopupCancellationPolicyClickedParams = {
  searchId: string;
  roomId: string;
  productDetailKey: string;
  optionIndex: number;
  desiredProfitPricingId: string;
};

export const createPopupCancellationPolicyClickedPayload = ({
  searchId,
  roomId,
  productDetailKey,
  optionIndex,
  desiredProfitPricingId,
}: PopupCancellationPolicyClickedParams): PopupCancellationPolicyClickedPayload => ({
  searchId,
  roomId,
  productDetailKey,
  optionIndex,
  desiredProfitPricingId,
});
